import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import { auth } from '../firebase';
import { useInvoicePrintLayout } from '../hooks/useInvoicePrintLayout';
import { InvoiceHeaderWithLogo, InvoicePrintBrowserHint, PardavejasWithBankBlock, PirkėjasBlock } from './InvoiceSharedParts';

const ADMIN_UID = 'w4JeMlHRtue6uPPAZKeOgLfKJkL2';

const BUYER_MB = {
  name: 'MB Pavyzdinė bendrija',
  address: 'Gedimino pr. 1, LT-01103 Vilnius',
  companyCode: '123456789',
  accountNo: '',
  bank: '',
  bankCode: '',
  swift: '',
};

const TEST_LINES = [
  { service: '85.51.00 - Sportinis rekreacinis švietimas', qty: 2, unitPrice: 40.0 },
  { service: 'Kita paslauga (pavyzdys)', qty: 1, unitPrice: 15.5 },
];

export default function InvoiceCoachMBTestPage() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [serialNo] = useState('01-0003');
  useInvoicePrintLayout('Sąskaita faktūra (MB)');

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (!user || user.uid !== ADMIN_UID) {
        navigate('/admin', { replace: true });
        return;
      }
      setChecking(false);
    });
    return () => unsub();
  }, [navigate]);

  if (checking) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography color="text.secondary">Kraunama...</Typography>
      </Box>
    );
  }

  const grandTotal = TEST_LINES.reduce((sum, line) => sum + (line.qty * line.unitPrice), 0);

  return (
    <Box className="invoice-document" sx={{ minHeight: '100vh', bgcolor: 'grey.100', '@media print': { minHeight: 'auto', bgcolor: 'white' } }}>
      <AppBar position="static" color="primary" sx={{ '@media print': { display: 'none' } }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Sąskaita faktūra - testas (MB pirkėjas)
          </Typography>
          <Button color="inherit" onClick={() => navigate('/admin/administracija')}>Atgal</Button>
          <Button color="inherit" onClick={() => window.print()}>Spausdinti / PDF</Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, '@media print': { p: 0, bgcolor: 'white' } }}>
        <Paper sx={{ maxWidth: '210mm', mx: 'auto', p: 4, fontFamily: 'Arial, Helvetica, sans-serif' }}>
          <InvoiceHeaderWithLogo title="Sąskaita faktūra" serialNo={serialNo} />

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, mb: 2 }}>
            <PirkėjasBlock buyer={BUYER_MB} />
            <PardavejasWithBankBlock />
          </Box>

          <TableContainer>
            <Table size="small" sx={{ border: '1px solid', borderColor: 'divider' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700, width: 56 }}>Eilės nr.</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Paslauga</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, width: 72 }}>Kiekis</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, width: 100 }}>Vnt kaina, Eur</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, width: 100 }}>Suma, Eur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TEST_LINES.map((line, idx) => {
                  const lineSum = line.qty * line.unitPrice;
                  return (
                    <TableRow key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{line.service}</TableCell>
                      <TableCell align="right">{line.qty}</TableCell>
                      <TableCell align="right">{line.unitPrice.toFixed(2)}</TableCell>
                      <TableCell align="right">{lineSum.toFixed(2)}</TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell colSpan={4} align="right" sx={{ fontWeight: 700 }}>Iš viso, Eur</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>{grandTotal.toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 5, display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="body1">Sąskaitą išrašė:</Typography>
            <Typography variant="body1" />
          </Box>
          <InvoicePrintBrowserHint />
        </Paper>
      </Box>
    </Box>
  );
}
